import ContractDetailsGeneral from 'features/ContractDetails/ContractDetailsGeneral/ContractDetailsGeneral'
import ContractDetailsFacilities from 'features/ContractDetails/Facilities/Facilities'
import { ContractItemsTable } from 'features/ContractItems/ContractItemsTable'
import RebateConditions from 'features/ContractDetails/RebateConditions/RebateConditions'
import Users from '../Users/Users'

export const contractDetailsRoute = {
  general: 'general',
  facilities: 'facilities',
  itemList: 'item_list',
  rebateConditions: 'rebate_conditions',
  users: 'users'
}

export const contractDetailsRoutes = [
  {
    path: contractDetailsRoute.general,
    component: ContractDetailsGeneral
  },
  {
    path: contractDetailsRoute.facilities,
    component: ContractDetailsFacilities
  },
  {
    path: contractDetailsRoute.users,
    component: Users
  },
  {
    path: contractDetailsRoute.itemList,
    component: ContractItemsTable
  },
  {
    path: contractDetailsRoute.rebateConditions,
    component: RebateConditions
  }
]
